module.exports = __webpack_public_path__ + "static/media/transaction1.9f05a12d.png";